module.exports = __webpack_public_path__ + "static/img/about-image.292e307.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/about-image.png
// module id = XQb1
// module chunks = 0